import { useMemo, useState } from 'react';
import { IdValue } from '../../types/props';
import { useLang } from '../../hooks/use-lang';
import { filterByName } from '../table/helpers';

export type NestedIdValue = {
  children?: NestedIdValue[];
} & IdValue;

export const useMultiSelect = (options: NestedIdValue[]) => {
  const { t } = useLang();

  const [search, setSearch] = useState('');

  const withSearchOptions = useMemo(() => {
    const isNested = options.some((item) => item.children?.length);
    if (isNested) {
      return options
        .map((item) => {
          if (!search) return item;

          return {
            ...item,
            children: item.children?.filter((child) => filterByName(child.value, search)),
          };
        })
        .filter((item) => item.children?.length);
    }
    return options.filter((item) => filterByName(item.value, search));
  }, [options, search]);

  return {
    setSearch,
    search,
    withSearchOptions,
    t,
  };
};
